import 'components/branchIO';
import 'components/accessibilityGeneral.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Search from 'components/search.js';
import LazyLoad from 'vanilla-lazyload';
import 'helpers/tracking.js';
import 'shared/touch_devices_detection';
import 'shared/cbs.ui';
import 'shared/ad_utils';
import FallbackImageManager from 'helpers/fallbackImageManager';

import InAppMessagingTemp from 'shared/inAppMessagingTemp';
import { UpdateFocusable } from 'components/accessibilityGeneral';
import  DMAService from '../services/DMAService.js'

import deeplinkTracking from 'services/DeeplinkTracking'

// VTD - video tracking debugger
import { Vtd } from '../video/shared/Vtd';
window._vtd = new Vtd();

let inAppMessagingTemp = new InAppMessagingTemp();
inAppMessagingTemp.init();

if (CBS.Registry.Features.braze_sdk === true) {
    (async () => {
        await import('helpers/brazePushTracking.js');
        const Braze = (await import('shared/Braze')).default;
        const brazePushTracking = (await import('helpers/brazePushTracking')).default;

        const brazeTrackingObj = new brazePushTracking();
        CBS.Tracking.utag_data = brazeTrackingObj.appendTrackingData(CBS.Tracking.utag_data);
        brazeTrackingObj.removeParamsFromUrl();

        new Braze();
    })();
}

let __header;
try {
    __header = new Header();
} catch (e) {
    console.error('Header component failed to load');
}

try {

    
    (async () => {
        let dmaInfo;

        if(CBS.Registry.pageType && CBS.Registry.pageType == "Search"){
            const dmaService = new DMAService();
            dmaInfo = await dmaService.getDMA();
        }


        let search = new Search(__header);
        search.extraParams = dmaInfo;
    })();

    

} catch (e) {
    console.error('Search component failed to load');
    console.error(e);
}

let lazyLoad = new LazyLoad({
    threshold: 50,
    elements_selector: '.lazy',
    callback_finish: () => {
        UpdateFocusable();
    },
    callback_error: (el) => {
        let parent = el.closest('.thumb-wrapper');

        let isCharacter = el.classList.contains('character-img');

        if (parent && !isCharacter) {
            let poster = CBS.Registry.fallbackImage.poster;
            let landscape = CBS.Registry.fallbackImage.landscape;

            let fallbackImage = FallbackImageManager.getFallBackImage(parent, poster, landscape);

            el.dataset.src = fallbackImage;
            CBS.Registry.lazyImage.resetElementStatus(el);
            CBS.Registry.lazyImage.update();
        }
    }
});

CBS.Registry.lazyImage = {
    resetElementStatus: (el) => lazyLoad.resetElementStatus(el),
    revalidate: () => lazyLoad.update(),
    update: () => lazyLoad.update(),
    load(element, force) {
        if (element && element.length !== undefined) {
            for (let i = 0; i < element.length; i++) {
                this.load(element[i]);
            }
        } else {
            lazyLoad.load(element, force);
        }
    }
};

if (CBS.Registry.bn) {
    console.log(CBS.Registry.bn);
}

(function () {
    let images = document.querySelectorAll('img');

    for (var i = 0; i < images.length; i++) {
        let img = images[i];
        img.onerror = () => {
            let parent = img.closest('.show-image');

            if (parent) {
                let fallbackImage = FallbackImageManager.getFallBackImage(
                    parent,
                    CBS.Registry.fallbackImage.poster,
                    CBS.Registry.fallbackImage.landscape
                );
                img.removeAttribute('srcset');
                img.src = fallbackImage;
            }
            img.onerror = null;
        };
    }
})();

/** 
 * Validate deeplink tracking after DOM content load
 */
document.addEventListener('DOMContentLoaded', deeplinkTracking().trackAction, false)
